module.exports = __webpack_public_path__ + "static/P2101558-953801913fa47903462d127c2734ffa6.jpg";